import { render, staticRenderFns } from "./pending-payments.vue?vue&type=template&id=883ddf36&scoped=true&"
import script from "./pending-payments.vue?vue&type=script&lang=js&"
export * from "./pending-payments.vue?vue&type=script&lang=js&"
import style0 from "./pending-payments.vue?vue&type=style&index=0&id=883ddf36&lang=scss&scoped=true&"
import style1 from "./pending-payments.vue?vue&type=style&index=1&id=883ddf36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883ddf36",
  null
  
)

export default component.exports